export class EvaluationTaxResult {
  taxPolicyId?: number;
  taxRuleId?: number;
  taxResultItemId?: number;
  taxResultItemTypeId?: number;
  rate?: number | undefined;
  description?: string | undefined;
  isActive?: boolean;
  securityTaxResultItemId?: number;
}
